module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"encryptionMessage":"Náhled dat není k dispozici kvůli šifrování."},"de":{"encryptionMessage":"Datenvorschau ist wegen der Verschlüsselung nicht verfügbar."},"es":{"encryptionMessage":"La vista previa de los datos no está disponible debido al cifrado del formulario."},"fr":{"encryptionMessage":"La prévisualisation des données n\u0027est pas disponible en raison du chiffrement."}}')
  delete Component.options._Ctor
}
